import TransactionsMain from "@/components/dashboard/transactions/TransactionsMain";

export default function Transactions() {
  return <TransactionsMain />;
}
